import { Link } from '@tanstack/react-router';

import { Button, Icon, PageHeader } from '~/components';

import styles from './routes.module.css';

/**
 * A page that does not exist.
 *
 * Says which one. "Page not found" with no path leaves a user unable to tell a
 * typo from a stale bookmark from a link somebody sent them that was wrong.
 */
export function NotFound() {
  const path = typeof window === 'undefined' ? '' : window.location.pathname;

  return (
    <>
      <PageHeader title="That page does not exist" />
      <div className={styles.notFound}>
        {path ? <p className={styles.notFoundCode}>{path}</p> : null}
        <p>
          The address is not one Exi Git serves. If you followed a link from inside the product,
          that is a bug worth reporting.
        </p>
        <Button asChild variant="primary" iconStart={<Icon.ChevronLeft />}>
          <Link to="/">Back to overview</Link>
        </Button>
      </div>
    </>
  );
}
